import * as React from 'react';
import { recentActivityData } from '../../../Shared/RecentActAndMessagesData';
import ScrollContainer from 'react-indiana-drag-scroll'
import { motion } from "framer-motion"

import TimeAgo from 'timeago-react';
import './RecentActivity.scss';
export interface IRecentActivityProps {
}

export function RecentActivity(props: IRecentActivityProps) {


    const handleLeftSideScroll = () => {
        const profileFilterOptionsBox = document.getElementById("profile_filter_options_box");
        profileFilterOptionsBox?.scrollBy(150, 0)
        // console.log('')
    }
    const handleRightSideScroll = () => {
        const profileFilterOptionsBox = document.getElementById("profile_filter_options_box");
        profileFilterOptionsBox?.scrollBy(-150, 0)
    }


    const filterOptionsStyles = "xs:px-2 sm:px-4 xs:py-1.5 sm:py-2.5 rounded-md flex justify-center items-center filter_option border-2 bg-white dark:bg-transparent dark:border-[#6561B1] text-[#6561B1] cursor-pointer select-none transition-all";


    return (
        <motion.div
            initial={{ opacity: 0, }}
            animate={{ opacity: 1, }}
            exit={{ opacity: 0, }}
            className="recent_activity_main_box fixed overflow-hidden xs:p-3 xs:pb-16 sm:p-5 md:pb-10 text-left
             top-[64px] w-full bottom-[79px]
                sm:top-[80px] sm:w-[454.67px]   
                md:bottom-0 border-l-2 dark:border-0
                shadow-2xl
                ">

            <h4 className="xs:text-xl md:text-base lg:text-lg font-extrabold dark:font-medium text-cusBlack dark:text-white">Recent Activity</h4>

            <div className="relative">
                <div className="left_arrow_bg h-full pr-10 absolute left-0 flex justify-end items-center z-50"></div>
                <div className="right_arrow_bg h-full pl-10 absolute right-0 flex justify-end items-center z-50"></div>
                <div id="profile_filter_options_box" className=" relative">
                    <div className="xl:hidden right_arrow_bg h-full xs:w-8 sm:w-12 absolute right-0 flex justify-end items-center"></div>

                    <ScrollContainer
                        nativeMobileScroll={true}
                        horizontal={true}
                        className="xs:my-5 profile_filter_options_box flex justify-start items-center px-8 xs:space-x-3 overflow-x-auto">

                        <input type="checkbox" name="recentListings" id="recentListings" className="hidden" />
                        <label htmlFor="recentListings">
                            <div className={filterOptionsStyles}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="15.833" height="15.834" viewBox="0 0 15.833 15.834">
                                    <path id="Path_853" data-name="Path 853" d="M28,133.083A7.917,7.917,0,1,0,35.916,141,7.924,7.924,0,0,0,28,133.083Zm.833,12.084H27.166a.834.834,0,0,1,0-1.667h1.667a.834.834,0,0,1,0,1.667Zm1.25-3.334H25.916a.833.833,0,1,1,0-1.666h4.167a.833.833,0,1,1,0,1.666Zm1.25-3.333H24.666a.834.834,0,0,1,0-1.667h6.667a.834.834,0,0,1,0,1.667Z" transform="translate(-20.083 -133.083)" fill="#6561b1" />
                                </svg>
                                <p className="text-sm ml-3">Listings</p>
                            </div>
                        </label>

                        <input type="checkbox" name="recentLike" id="recentLike" className="hidden" />
                        <label htmlFor="recentLike">
                            <div className={filterOptionsStyles}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="15.83" height={15} viewBox="0 0 15.83 15">
                                    <path id="Path_873" data-name="Path 873" d="M161.808,139.8c-.8,4.08-4.978,6.945-6.739,7.989a2.1,2.1,0,0,1-2.137,0c-1.762-1.044-5.944-3.909-6.74-7.989a5.909,5.909,0,0,1,1.211-4.84,5,5,0,0,1,3.907-1.879,5.416,5.416,0,0,1,2.69.7,5.421,5.421,0,0,1,2.69-.7,5,5,0,0,1,3.908,1.879A5.912,5.912,0,0,1,161.808,139.8Z" transform="translate(-146.085 -133.083)" fill="#6561b1" />
                                </svg>
                                <p className="text-sm ml-3">Like</p>
                            </div>
                        </label>

                        <input type="checkbox" name="recentPurchases" id="recentPurchases" className="hidden" />
                        <label htmlFor="recentPurchases">
                            <div className={filterOptionsStyles}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16.667" height="16.666" viewBox="0 0 16.667 16.666">
                                    <path id="Path_865" data-name="Path 865" d="M257.768,140.361h2.307a.638.638,0,0,0,0-1.276h-2.307a.638.638,0,0,0,0,1.276Zm5.046-4.421a1.405,1.405,0,0,1,1.174.569,1.84,1.84,0,0,1,.317,1.462l-.791,5.579a2.141,2.141,0,0,1-2.107,1.863h-9.085a2.141,2.141,0,0,1-2.115-1.99l-.766-9.27-1.257-.221a.638.638,0,0,1,.216-1.258l1.986.305a.638.638,0,0,1,.517.579l.158,1.9a.512.512,0,0,0,.508.477Zm-10.625,10.817a1.288,1.288,0,1,0,1.257,1.292A1.278,1.278,0,0,0,252.189,146.757Zm9.368,0a1.288,1.288,0,1,0,1.257,1.292A1.278,1.278,0,0,0,261.557,146.757Z" transform="translate(-247.667 -132.667)" fill="#6561b1" fillRule="evenodd" />
                                </svg>
                                <p className="text-sm ml-3">Purchases</p>
                            </div>
                        </label>

                        <input type="checkbox" name="recentSales" id="recentSales" className="hidden" />
                        <label htmlFor="recentSales">
                            <div className={filterOptionsStyles}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16.667" height="16.666" viewBox="0 0 16.667 16.666">
                                    <path id="Path_865" data-name="Path 865" d="M257.768,140.361h2.307a.638.638,0,0,0,0-1.276h-2.307a.638.638,0,0,0,0,1.276Zm5.046-4.421a1.405,1.405,0,0,1,1.174.569,1.84,1.84,0,0,1,.317,1.462l-.791,5.579a2.141,2.141,0,0,1-2.107,1.863h-9.085a2.141,2.141,0,0,1-2.115-1.99l-.766-9.27-1.257-.221a.638.638,0,0,1,.216-1.258l1.986.305a.638.638,0,0,1,.517.579l.158,1.9a.512.512,0,0,0,.508.477Zm-10.625,10.817a1.288,1.288,0,1,0,1.257,1.292A1.278,1.278,0,0,0,252.189,146.757Zm9.368,0a1.288,1.288,0,1,0,1.257,1.292A1.278,1.278,0,0,0,261.557,146.757Z" transform="translate(-247.667 -132.667)" fill="#6561b1" fillRule="evenodd" />
                                </svg>
                                <p className="text-sm ml-3">Sales</p>
                            </div>
                        </label>

                        <input type="checkbox" name="recentTransfer" id="recentTransfer" className="hidden" />
                        <label htmlFor="recentTransfer">
                            <div className={filterOptionsStyles}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="17.103" height="16.666" viewBox="0 0 17.103 16.666">
                                    <path id="exchange" d="M16.644,10.8a1.57,1.57,0,1,1-2.22,2.22L13.3,11.9v9.736a1.57,1.57,0,1,1-3.14,0V8.113A1.57,1.57,0,0,1,12.841,7ZM4.262,22.749a1.57,1.57,0,0,0,2.68-1.11V8.113a1.57,1.57,0,1,0-3.14,0v9.736L2.68,16.726a1.57,1.57,0,1,0-2.22,2.22Z" transform="translate(0 -6.543)" fill="#6561b1" />
                                </svg>
                                <p className="text-sm ml-3">Transfer</p>
                            </div>
                        </label>

                        <input type="checkbox" name="recentBurns" id="recentBurns" className="hidden" />
                        <label htmlFor="recentBurns">
                            <div className={filterOptionsStyles}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12.157" height="16.21" viewBox="0 0 12.157 16.21">
                                    <path id="Path_662" data-name="Path 662" d="M114.1,342c-3.454,1.991-3.039,7.6-3.039,7.6s-1.52-.507-1.52-2.786a6.176,6.176,0,0,0-3.039,5.318,6.079,6.079,0,0,0,12.157,0c0-4.939-4.559-5.952-4.559-10.131Zm-.986,14.116a2.28,2.28,0,1,1-1.1-4.424c2.949-.735,3.319-2.394,3.319-2.394s1.47,5.9-2.216,6.818Z" transform="translate(-106.5 -342)" fill="#6561b1" />
                                </svg>
                                <p className="text-sm ml-3">Burns</p>
                            </div>
                        </label>

                        <input type="checkbox" name="recentBids" id="recentBids" className="hidden" />
                        <label htmlFor="recentBids">
                            <div className={filterOptionsStyles}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16.669" height="15.835" viewBox="0 0 16.669 15.835">
                                    <path id="Path_874" data-name="Path 874" d="M275.932,196.933a.919.919,0,0,0-.266.809l.741,4.1a.9.9,0,0,1-.375.9.917.917,0,0,1-.975.066l-3.691-1.925a.944.944,0,0,0-.417-.109h-.226a.7.7,0,0,0-.225.075l-3.691,1.934a.969.969,0,0,1-.592.092.927.927,0,0,1-.742-1.059l.742-4.1a.934.934,0,0,0-.266-.816l-3.009-2.917a.9.9,0,0,1-.224-.941.936.936,0,0,1,.741-.625l4.141-.6a.928.928,0,0,0,.734-.508l1.825-3.741a.858.858,0,0,1,.166-.225l.075-.059a.583.583,0,0,1,.135-.108l.09-.033.142-.059h.351a.933.933,0,0,1,.733.5l1.849,3.725a.928.928,0,0,0,.692.508l4.142.6a.943.943,0,0,1,.758.625.9.9,0,0,1-.242.941Z" transform="translate(-262.666 -187.083)" fill="#6561b1" />
                                </svg>
                                <p className="text-sm ml-3">Bids</p>
                            </div>
                        </label>

                        <input type="checkbox" name="recentFollowing" id="recentFollowing" className="hidden" />
                        <label htmlFor="recentFollowing">
                            <div className={filterOptionsStyles}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="15.833" height="14.166" viewBox="0 0 15.833 14.166">
                                    <path id="Path_863" data-name="Path 863" d="M138.916,253.7v.425a2.673,2.673,0,0,1-.591,1.683.767.767,0,0,1-.617.275h-2.233a3.92,3.92,0,0,0,.525-1.958V253.7a4.72,4.72,0,0,0-1.192-3.15.885.885,0,0,0,.158-.075,1.819,1.819,0,0,1,1.309-.175A3.5,3.5,0,0,1,138.916,253.7Zm-5.833-11.783a3.415,3.415,0,0,0-.775.083,4.984,4.984,0,0,1,0,7.333,3.359,3.359,0,0,0,.775.084,3.75,3.75,0,0,0,0-7.5Zm-4.167,0a3.75,3.75,0,1,0,3.75,3.75A3.756,3.756,0,0,0,128.916,241.917Zm3.192,8.383a2.017,2.017,0,0,0-.442-.05,1.721,1.721,0,0,0-.866.225,3.968,3.968,0,0,1-3.75.008,1.875,1.875,0,0,0-.892-.233,1.928,1.928,0,0,0-.383.042,3.48,3.48,0,0,0-2.692,3.408v.425a2.669,2.669,0,0,0,.592,1.683.765.765,0,0,0,.616.275h9.25a.767.767,0,0,0,.617-.275,2.674,2.674,0,0,0,.592-1.683V253.7A3.5,3.5,0,0,0,132.108,250.3Z" transform="translate(-123.083 -241.917)" fill="#6561b1" />
                                </svg>
                                <p className="text-sm ml-3">Following</p>
                            </div>
                        </label>

                    </ScrollContainer>
                </div>
            </div>





            <div className="px-6 xs:pb-14 sm:pb-24 mt-4 h-full overflow-auto">
                {recentActivityData.map(data =>
                    <div className="flex justify-start items-center mb-4" key={data.id}>
                        <div className="xs:w-10 sm:w-12 xs:h-10 sm:h-12 rounded-full">
                            <img src={data.profLogo} alt="" className="w-full h-full" />
                        </div>

                        <div className="ml-5 text-left">
                            <h4 className="xs:text-sm xl:text-lg text-cusBlack dark:text-white">{data.activityTitle}</h4>
                            <TimeAgo
                                className="text-cusBlack dark:text-cusBlueWhite text-xs "
                                datetime={data.time}
                                // datetime="2022-06-25 08:08:08"
                                locale='en_US'
                            />
                        </div>
                    </div>
                )}
            </div>


        </motion.div>
    );
}
